/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pProgress.vue?vue&type=template&id=bf84609a"
import script from "./pProgress.vue?vue&type=script&lang=js"
export * from "./pProgress.vue?vue&type=script&lang=js"
import style0 from "./pProgress.vue?vue&type=style&index=0&id=bf84609a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports